<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('homePageBanner')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Add Banner</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <p>Heading</p>
        <base-input
          alternative
          class="mb-3"
          name="Heading"
          :rules="{ required: true }"
          placeholder="Heading"
          v-model="heading"
        >
        </base-input>

        <p>Sub Heading</p>
        <base-input
          alternative
          class="mb-3"
          name="Sub Heading"
          :rules="{ required: true }"
          placeholder="Sub Heading"
          v-model="content"
        >
        </base-input>

        <p>Button Label</p>
        <base-input
          alternative
          class="mb-3"
          name="Button Label"
          :rules="{ required: true }"
          placeholder="Button Label"
          v-model="btnName"
        >
        </base-input>

        <div
          class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
        >
          Recommended Size: 800 × 500px
        </div>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        <Cropper
          class="cropper"
          :src="image"
          v-if="coverImage != ''"
          @change="handleCropperChange"
          ref="cropper"
        />
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>

        <img v-if="image" :src="image" ref="cover" />

        <div class="py-4 customboxed">
          <p>Redirect Link</p>
          <base-input
            class="mb-3"
            name="Link"
            :rules="{
              required: true,
            }"
            placeholder="Add your Page link"
            v-model="link"
          >
          </base-input>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";
import "vue-advanced-cropper/dist/style.css";
import { Cropper } from "vue-advanced-cropper";
// import Data from "../../../../../admin/pages/add-product/components/Data";

export default {
  components: {
    FileUploader,
    quillEditor,
    Cropper,
  },
  data() {
    return {
      heading: "",
      link: "",
      image: null,
      cropperImg: "",
      coverImage: null,
      content: "",
      btnName: "",
      editorOption: {
        theme: "snow",
      },
      linkErr: false,
      imageErr: false,
      msg: {
        image: "",
      },
    };
  },
  computed: {
    ...mapState("cms", {
      pageCategories: "pageCategories",
      selectedpagecategory: "selectedpagecategory",
    }),
  },
  methods: {
    handleCropperChange(img) {
      // console.log(img);
      this.cropperImg = this.$refs.cropper.getResult().canvas.toDataURL();
      this.coverImage = this.dataURLtoFile(img.canvas.toDataURL(), "image.png");
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },

    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();

      data.append("heading", this.heading);
      data.append("image", this.coverImage);
      data.append("content", this.content);
      data.append("btnName", this.btnName);
      data.append("link", this.link);
      let loader = this.$loading();

      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      try {
        const newsdata = await this.$store.dispatch(
          "homePageBanner/create",
          data
        );

        // if (newsdata.code == 200) {
        this.$router.push({ name: "homePageBanner" });
        this.$swal.fire({
          text: "Banner Successfully Added",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        // }
        loader.close();
      } catch (error) {
        if (error.response.status) {
          this.$swal.fire({
            title: "Error",

            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      }
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
